import React, { useEffect } from "react";

const AdComponent = () => {
	useEffect(() => {
		try {
			(window.adsbygoogle = window.adsbygoogle || []).push({});
		} catch (e) {
			console.error("Adsense error", e);
		}
	}, []);

	return (
		<ins class="adsbygoogle"
			style={{ display: "block" }}
			data-ad-format="fluid"
			data-ad-layout-key="-fb+5w+4e-db+86"
			data-ad-client="ca-pub-8919281978138727"
			data-ad-slot="7665566166"></ins>
	);
};

export default AdComponent;
